"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M16 9H4c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"];
//# sourceMappingURL=minus.js.map